export const brand = {
  "name": "Zenvoya",
  "assistantName": "Zoya",
  "logo": {
    "wordmark": "/brand/logo/wordmark.svg",
    "booking": "/brand/logo/booking.svg"
  },
  "chatAvatar": "/brand/illustrations/chat-avatar.svg",
  "sidebarMascot": "/brand/logo/sidebar-mascot.svg",
  "images": {
    "assistantMark": "/brand/images/fox.svg",
    "assistantMarkPassive": "/brand/images/fox-passive.png",
    "character": "/brand/images/character.svg",
    "askAssistant": "/brand/images/ask-assistant.png",
    "supportMascot": "/brand/images/support-mascot.png",
    "homeBg": "/brand/images/home-bg.svg",
    "assistantLuggage": "/brand/images/travel-booking-confirmation.svg",
    "chatLoader": "/brand/images/fox.svg",
    "avatar": "/brand/images/avatar.png",
    "mapFox": "/brand/images/map-empty-comments.svg",
    "confirmLogo": "/brand/images/travel-booking-confirmation.svg",
    "failedLogo": "/brand/images/travel-booking-failed.svg",
    "activityUnavailable": "/brand/images/travel-booking-failed.svg",
    "supportIcon": "/brand/images/24-7-support-flights-hotels.svg",
    "activityHelp": "/brand/images/24-7-support-activities.svg"
  }
} as const;
